import { FnCoCompanyCode, FnHoldingsCompanyCode } from '@/constant';

export const isFnCo = (companyCode: string) =>
  FnCoCompanyCode.includes(companyCode);

export const isFnHolding = (companyCode: string) =>
  FnHoldingsCompanyCode.includes(companyCode);
